import zwitCore from "./config/http";
const BASE_URL = process.env.NODE_ENV === "development" ? "/apis" : "";

export default {
  getIncludeList() {
    return zwitCore.HTTP.get(BASE_URL + "/zw-public/include/includeList");
  },
  getYearList(data) {
    return zwitCore.HTTP.get(BASE_URL + "/zw-public/year/infoPage", data);
  },
  getSubjectList() {
    return zwitCore.HTTP.get(BASE_URL + "/zw-public/researchField/getAllList");
  },
};
